import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4A5568",
      "fill-rule": "evenodd",
      d: "M15.657 15.657A8 8 0 1 1 4.343 4.342a8 8 0 0 1 11.314 11.315m-3.92-3.04h-3.06q.147-.222.288-.38.327-.4 1.207-1.12.885-.72 1.26-1.055.375-.34.732-.931a2.5 2.5 0 0 0 .188-2.215 2.34 2.34 0 0 0-1.202-1.277q-.632-.282-1.529-.282-.745 0-1.3.223a2.7 2.7 0 0 0-.915.574 2.4 2.4 0 0 0-.539.797 2.2 2.2 0 0 0-.181.844q0 .334.193.527a.66.66 0 0 0 .486.194q.334 0 .504-.211.175-.21.31-.604.14-.393.2-.48.44-.675 1.207-.674.363 0 .668.164.31.165.486.463.182.293.182.668 0 .346-.17.709-.165.357-.486.703-.317.34-.797.68-.27.181-.897.761-.626.575-1.406 1.383-.187.2-.346.55-.158.347-.158.557 0 .329.246.575.246.24.686.24h4.312q.388 0 .574-.2a.67.67 0 0 0 .194-.486.61.61 0 0 0-.24-.51q-.24-.186-.698-.187",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }